export default "__VITE_ASSET__BTbp$Oyc__"